// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1__d6c7a43becd53b821648","cls2":"LanguageSwitcherModal-cls2___002066a559f9886c35d LanguageSwitcherModal-cls1__d6c7a43becd53b821648"};